module.exports = __webpack_public_path__ + "img/product_0_2.4e730c03.jpg";